import { AsyncButton } from "aic";
import { useTlfContext } from "contexts/AppSettingsContext";
import { REDO_TLF_CHANGE, UNDO_TLF_CHANGE } from "contexts/tlf/interface";
import { ReactNode } from "react";
import { ButtonGroup } from "react-bootstrap";
import { ArrowClockwise, ArrowCounterclockwise } from "react-bootstrap-icons";

/**
 * Undo/redo toolbar buttons for the TLF editor. Integrates with the editor's
 * command stack to perform undo, redo, and clear history actions and updates
 * the UI disabled state accordingly.
 *
 * @returns A set of toolbar buttons for undo and redo operations.
 */
export const TlfUndoButtons = (): ReactNode => {
  const tlfContext = useTlfContext();
  return !tlfContext.tlfData || tlfContext.readOnly ? null : (
    <div style={{ position: "relative", width: "100%" }}>
      <ButtonGroup style={{ position: "absolute", top: "-16px", right: 0, zIndex: 2 }}>
        <AsyncButton
          id="tlf-undo-button"
          className="border border-dark"
          variant="warning"
          size="sm"
          aria-label="Undo"
          onClick={() =>
            tlfContext.dispatch({ operation: UNDO_TLF_CHANGE, calledFrom: "TlfUndoButtons:Undo" })
          }
          disabled={tlfContext.readOnly || tlfContext.ixTlfDataVersion === 0}
        >
          <ArrowCounterclockwise />
        </AsyncButton>
        <AsyncButton
          id="tlf-redo-button"
          className="border border-dark"
          variant="warning"
          size="sm"
          aria-label="Redo"
          onClick={() =>
            tlfContext.dispatch({ operation: REDO_TLF_CHANGE, calledFrom: "TlfUndoButtons:Redo" })
          }
          disabled={
            tlfContext.readOnly ||
            tlfContext.ixTlfDataVersion >= tlfContext.tlfDataVersions.length - 1
          }
        >
          <ArrowClockwise />
        </AsyncButton>
      </ButtonGroup>
    </div>
  );
};

TlfUndoButtons.displayName = "TlfUndoButtons";
